import personalInquiryQueryFunction from '@/modules/adjusterReportModules/IncidentParticipants/queries/personalInquiryQuery/personalInquiry.function.ts';
import {
  PersonalInquiryParams,
  PersonalInquiryResponse,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/personalInquiryQuery/personalInquiry.types.ts';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const usePersonalInquiryQueryOptions = (): MutationOptions<
  AxiosResponse<PersonalInquiryResponse, any>,
  Error,
  PersonalInquiryParams
> => ({
  mutationKey: ['personalInquiry'],
  mutationFn: ({ param }: PersonalInquiryParams) =>
    personalInquiryQueryFunction({ param }),
});
